import * as axios from "axios";
import { webStore, clearAuth } from "store";

var axiosObject = axios.default.create();

axiosObject.defaults.baseURL = process.env.NEXT_PUBLIC_API_URL;

axiosObject.defaults.headers.common = {
    "Content-Type": "application/json",
    Accept: "application/json",
};

axiosObject.interceptors.request.use(
    async function (config: any) {
        config.headers["Authorization"] = `Bearer ${webStore.getState().adminAuth.accessToken
            }`;
        return config;
    },
    function (error: any) {
        return Promise.reject(error);
    }
);

axiosObject.interceptors.response.use(
    function (response: any) {
        return response;
    },
    function (error: any) {
        if (error.message.includes("500")) {
            console.log("server error!");
        } else if (error.message.includes("403")) {
            webStore.dispatch(clearAuth());
        }
        return Promise.reject(error);
    }
);

export { axiosObject };
